module.exports = __webpack_public_path__ + "static/media/html5.664a8c00.png";